import SongSearchList from './SongSearchList'

function AddSongDrawer({ onAddSong, onClose }) {
  const handleSelect = (song) => {
    onAddSong(song)
    onClose()
  }

  return (
    <>
      <div className="add-song-backdrop" onClick={onClose} />
      <div className="add-song-drawer frosted ticks">
        <SongSearchList autoFocus onSelect={handleSelect} />
      </div>
    </>
  )
}

export default AddSongDrawer
